import {css, unsafeCSS} from "lit";
import {sbkCoreBreakpointMd, sbkCoreBreakpointXl} from "@/tokens/variables";

const breakpointMd = unsafeCSS(`${sbkCoreBreakpointMd}`);
const breakpointXl = unsafeCSS(`${sbkCoreBreakpointXl}`);

export const modalFlyoutStyles = css`
    .wrapper {
        display: flex;
        @media (min-width: ${breakpointXl}) {
            position: relative;
        }
    }

    .modal-flyout {
        display: none;
        position: absolute;
        width: 100%;
        z-index: 11;

        left: unset;
        right: 0;
        top: var(--sbkTopNavBarSizingLargeScreenFixedBarHeight);
        
        padding: 0;
        background-color: var(--modal-background__color);
        color: var(--modal__color);
        border: none;
        font: var(--modal-body__font);
        height: calc(100vh - var(--sbkTopNavBarSizingLargeScreenFixedBarHeight));

        @media (min-width: ${breakpointMd}) {
            width: var(--sbkNavFlyoutSizingMdFixedWidth);
            max-width: var(--sbkModalSizingMaxWidthMdViewport);
            border-top: var(--sbkNavFlyoutBorderTop);
        }

        @media (min-width: ${breakpointXl}) {
            width: 400px;
            top: var(--sbkCoreSpacing4xl);
            right: 0;
            border: none;
            border-radius: var(--sbkModalBorderRadiiusLg);
            height: unset;
            max-width: var(--sbkModalSizingMaxWidthLgViewport);
            max-height: calc(100vh - var(--sbkModalSpacingLargeScrMargin) - var(--sbkModalSpacingLargeScrMargin));
        }
    }

    .modal-flyout.expanded {
        display: block;
    }

    .modal-flyout__header {
        padding: var(--modal-header__padding-top) var(--modal-header__padding-right) var(--modal-header__padding-bottom) var(--modal-header__padding-left);
        display: flex;
        justify-content: space-between;
        align-items: center;
        gap: var(--modal-header__gap);
        font: var(--modal-title__font);
        border-bottom: var(--sbkModalBorderTitleAreaBottom);
        z-index: 1;
    }

    .modal-flyout__content {
        display: flex;
        overflow-y: auto;
        flex-grow: 1;
        flex-direction: column;
        padding: var(--modal-content__padding-top) var(--modal-content__padding-right) 0 var(--modal-content__padding-left);
        gap: var(--sbkCoreSpacingXl);
    }

    .modal-flyout__header h3 {
        font: var(--headline__text);
        margin: 0;
    }

    .modal-flyout__footer {
        display: flex;
        justify-content: center;
        padding: var(--modal-button__padding);
        flex-direction: column;
        gap: var(--modal-button__gap);
        align-items: center;

        @media (min-width: ${breakpointMd}) {
            flex-direction: row;
        }
    }

    .backdrop {
        display: none;
    }

    .backdrop.expanded {
        display: block;
        position: absolute;
        top: var(--sbkTopNavBarSizingLargeScreenFixedBarHeight);
        left: 0;
        width: 100%;
        height: calc(100vh - var(--sbkTopNavBarSizingLargeScreenFixedBarHeight));
        z-index: 9;
        background-color: var(--sbkNavFlyoutColorBackdrop);

        @media all and (max-width: ${breakpointXl}) {
            top: var(--sbkTopNavBarSizingSmallScreenFixedBarHeight)
        }
    }
`;